import React from "react";

export default function MaintenancePage() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-start px-4 py-10 bg-white">
      {/* Logo */}
      <div className="flex items-center justify-center mb-10">
        <img
          src="/assests/images/pixell dark.png"
          alt="logo"
          className="h-12 w-auto"
        />
      </div>

      {/* Heading */}
      <h1 className="text-3xl font-bold text-gray-500 text-center mb-10">
        We’ll Be Back Soon
      </h1>

      {/* Sub heading text */}
      <p className="text-gray-400 text-lg  text-center max-w-2xl mb-10">
        Our website is down for scheduled maintenance and will be back online
        after some time.
      </p>

      {/* Illustration */}
      <div className="w-full flex justify-center mb-10">
        <img
          src="/assests/images/maintenance.png" // your illustration
          alt="maintenance"
          className="max-w-xl w-full"
        />
      </div>
    </div>
  );
}
